import { Box } from "@chakra-ui/react";

interface SearchResultCountProps {
  count?: number;
}

export function SearchResultCount({ count }: SearchResultCountProps) {
  return (
    <Box className="body2 gray600" padding="0 24px">
      <span className="orange650">{count}</span>건의 검색 결과가 있습니다.
    </Box>
  );
}
